import { Box, Grid2, Typography } from "@mui/material";
import { FormEvent, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Navigate, redirect, useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { BrandEnum } from "../../_common/enum/brand.enum";
import { StandardButton } from "../../_components/button/primary.button";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { RESET_PASSWORD_ERROR_MESSAGES, RESET_PASSWORD_HELPER_TEXT, RESET_PASSWORD_VALIDATORS } from "../../_const/security.const";
import { accountService } from "../../_services/accounts.service";
import { authScreenStyles } from "../../_styles/authScreen.styles";
import { AuthLogo } from "./_components/authLogo";


export function LoginResetPassword(params: { brand: BrandEnum }) {

    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

    let { pathname } = useLocation();
    let code = pathname && pathname.indexOf("code=") ? pathname.split("code=")[1] : "";
    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);

        accountService.resetPassword(username, password, confirmPassword, code)
            .then(
                (item => {
                    toastr.success("Password reset successfully");
                    navigate("/");
                }),
                ((err) => {
                    toastr.error(err.Message || err.title || err || "Something went wrong. Please try again later");
                }))
            .finally(() => { setLoading(false); });
    }

    function generateGuid() {
        var result, i, j;
        result = '';
        for (j = 0; j < 32; j++) {
            if (j == 8 || j == 12 || j == 16 || j == 20)
                result = result + '-';
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return result;
    }

    return (
        <>
            <AuthLogo brand={params.brand} />

            <Typography sx={authScreenStyles.subheading}>
                Set a new password for your account
            </Typography>

            <ValidatorForm onSubmit={submit} noValidate style={authScreenStyles.form}>
                <Grid2 container spacing={2} sx={authScreenStyles.formContainer}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            required
                            fullWidth
                            label="Email"
                            name="email"
                            value={username}
                            disabled={isLoading}
                            onChange={(e: any) => setUsername(e.target.value.toString())}
                            validators={["required", "isEmail"]}
                            errorMessages={["This field is required", "Email is not valid"]}
                            autoFocus
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            disabled={isLoading}
                            value={password}
                            withRequiredValidator
                            autoComplete={`current-password-${generateGuid()}`}
                            onChange={(e: any) => setPassword(e.target.value.toString())}
                            validators={RESET_PASSWORD_VALIDATORS(true)}
                            errorMessages={RESET_PASSWORD_ERROR_MESSAGES(true)}
                            helperText={
                                !password ? RESET_PASSWORD_HELPER_TEXT : "✓ Password is valid"
                            }
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            error={Boolean(confirmPassword) && password !== confirmPassword}
                            required
                            fullWidth
                            name="confirmpassword"
                            label="Confirm Password"
                            type="password"
                            id="confirmpassword"
                            disabled={isLoading}
                            value={confirmPassword}
                            withRequiredValidator
                            onChange={(e: any) => setConfirmPassword(e.target.value.toString())}
                            validators={["required", "minStringLength:6"]}
                            errorMessages={[
                                "This field is required",
                                "This field must be at least 6 characters long",
                            ]}
                            autoComplete={`current-password-confirm-${generateGuid()}`}
                            helperText={password && confirmPassword && password === confirmPassword ? `✓ Passwords match` : confirmPassword ? "Passwords don't match" : ""}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            type="submit"
                            variant="primary"
                            loading={isLoading}
                            icon={"lock_reset"}>
                            Reset Password
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>

            <Box sx={authScreenStyles.linkContainer}>
                <Link style={authScreenStyles.link} to="/login">
                    Back to Log In screen
                </Link>
            </Box>
        </>
    );
}